import http from "../http-common";

class VisitDataService{

    getVisits() {
        return http.get('/visits');
    }
    
    getVisit(id) {
        return http.get(`/visits/${id}`);
    }
    
    createVisit(data) {
        return http.post('/visits', data);
    }
    
    updateVisit(id, data) {
        return http.put(`/visits/${id}`, data);
    }
    
    deleteVisit(id) {
        return http.delete(`/visits/${id}`);
    }
    
    getVisitsByClient(clientId) {
        return http.get(`/visits?client_id=${clientId}`);
    }

    getAppointmentsByClient(clientId) {
        return http.get(`/clients/${clientId}/appointments`);
    }

    getExamTypes(search = '') {
        const query = search ? `?search=${encodeURIComponent(search)}` : '';
        return http.get(`/elists${query}`);
    }

    createExamType(data) {
        return http.post('/elists', data);
    }

    // Exam management methods
    getExamsByVisit(visitId) {
        return http.get(`/visits/${visitId}/exams`);
    }

    getPendingExamsByClient(clientId) {
        return http.get(`/clients/${clientId}/exams/pending`);
    }
    
    createExam(data) {
        return http.post('/exams', data);
    }
    
    updateExam(id, data) {
        return http.put(`/exams/${id}`, data);
    }
    
    deleteExam(id) {
        return http.delete(`/exams/${id}`);
    }

    // Prescription management methods
    getPrescriptionsByVisit(visitId) {
        return http.get(`/visits/${visitId}/prescriptions`);
    }
    
    createPrescriptionForVisit(visitId, data) {
        return http.post(`/visits/${visitId}/prescriptions`, data);
    }
    
    createPrescription(data) {
        return http.post('/prescriptions', data);
    }
    
    updatePrescription(id, data) {
        return http.put(`/prescriptions/${id}`, data);
    }
    
    deletePrescription(id) {
        return http.delete(`/prescriptions/${id}`);
    }
    
    getActivePrescriptionsByClient(clientId) {
        return http.get(`/prescriptions/client/${clientId}/active`);
    }
    
    getPrescriptionsByStatus(status) {
        return http.get(`/prescriptions/status/${status}`);
    }

    // Invoice management methods
    getInvoices() {
        return http.get('/invoices');
    }
    
    getInvoicesByVisit(visitId) {
        return http.get(`/invoices?visit_id=${visitId}`);
    }
    
    createInvoice(data) {
        return http.post('/invoices', data);
    }
    
    updateInvoice(id, data) {
        return http.put(`/invoices/${id}`, data);
    }
    
    deleteInvoice(id) {
        return http.delete(`/invoices/${id}`);
    }

}

export default new VisitDataService();